import { useState } from 'react'

import { useShowOnce } from 'utils/hooks/useShowOnce'
import useToggleSdkContext from 'utils/useToogleSdk'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

type KemudahanSurveyDialogType =
  | 'perencanaan-pamong'
  | 'pelaksanaan-pamong'
  | 'perencanaan-kepala-skb'
  | 'pelaksanaan-kepala-skb'
  | 'perencanaan-penilik'
  | 'pelaksanaan-penilik'
  | 'kinerja-harian'

type Params = {
  type: KemudahanSurveyDialogType
  additionalKey?: string
}

type Return = {
  isEnabled: boolean
  isOpen: boolean
  isSubmitted: boolean
  open: () => void
  close: () => void
  markAsSubmitted: () => void
}

export function useKemudahanSurveyDialog({
  type,
  additionalKey,
}: Params): Return {
  const { period } = usePeriodContext()

  const toggles = useToggleSdkContext()
  const isSurveyEnabled = toggles?.['kinerja-survei-kemudahan-enabled'] || false

  const { hasBeenShown, markAsShown } = useShowOnce(
    `kinerja-survei-kemudahan-${type}-${period?.id}-${additionalKey}`
  )

  const [isOpen, setIsOpen] = useState(false)

  return {
    isEnabled: isSurveyEnabled,
    isOpen: isOpen,
    isSubmitted: hasBeenShown,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    markAsSubmitted: markAsShown,
  }
}
